import { render, staticRenderFns } from "./JoinORPInviteForm.vue?vue&type=template&id=765c531e"
import script from "./JoinORPInviteForm.vue?vue&type=script&lang=js"
export * from "./JoinORPInviteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports